import { useContext } from 'react';
import ScreenshotContext from './ScreenshotContext';

export const useScreenshotContext = () => useContext(ScreenshotContext);
